import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMockFi: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'L.A. Jackson perustaa London Rubber Companyn ja myy maahantuotuja kondomeja ja välineitä.',
		},
		{
			year: 1929,
			description: 'The London Rubber Company (LRC) rekisteröi Durex-tuotemerkin.',
		},
		{
			year: '1950-luku',
			description: 'Durex tuo markkinoille ensimmäisen liukastetun kondomin.',
		},
		{
			year: 1953,
			description: 'Ensimmäisenä kondominvalmistajana Durex kehittää sähköisen testimenetelmän ja ottaa sen käyttöön.',
		},
		{
			year: '1960-luku',
			description: 'Durex tuo markkinoille ensimmäisen anatomisesti muotoillun kondomin.',
		},
		{
			year: '1970-luku',
			description: 'Durex on maailman ensimmäinen kondomimerkki, joka mainostaa tuotteitaan useassa maassa.',
		},
		{
			year: '1990-luku',
			description: 'Durex on ensimmäinen kondomimerkki, joka ottaa maailmanlaajuisen laatusinetin standardikseen.',
		},
		{
			year: 1995,
			description: 'Durex lanseeraa valikoiman erivärisiä ja -makuisia kondomeja.',
		},
		{
			year: 1996,
			description: 'Durex on ensimmäinen kondomimerkki, jolla on internet-sivusto. Nykyään Durexilla on yhteensä 42 verkkosivustoa maissa, joissa Durexia markkinoidaan.',
		},
		{
			year: 1997,
			description: 'Durex tuo markkinoille lateksittomat kondomit. Tuote on valmistettu uudenlaisesta allergisoimattomasta materiaalista – synteettisestä polyuretaanista – joka on Durexin kehittämä, luonnonlateksia pehmeämpi ja joustavampi materiaali.',
		},
		{
			year: 1998,
			description: 'Durex toteuttaa ensimmäisenä kondomiyrityksenä maailmanlaajuisen seksuaaliterveyttä koskevan kyselytutkimuksen.',
		},
		{
			year: 2001,
			description: 'Durex tuo markkinoille Pleasuremaxin. Durex on siten ensimmäinen kondomimerkki, joka kehittää molempien osapuolten nautintoa maksimoivan juomu- ja nystypintaisen kondomin.',
		},
		{
			year: 2003,
			description: 'Durex lanseeraa jännittävän ja uudenlaisen Play-liukuvoidevalikoiman.',
		},
		{
			year: 2005,
			description: 'Durex Network aloittaa Face of Global Sex -raporttien julkaisemisen. Ihmisten seksuaalista käyttäytymistä kartoittavat raportit tuotetaan ensisijaisesti tutkijoiden ja päättäjien tarpeisiin.',
		},
		{
			year: 2008,
			description: 'Durex pyytää 16–24-vuotiaita nuoria suunnittelemaan julisteen nuorten turvallista seksiä edistävään kampanjaansa. Ainutlaatuinen juliste on nuorten itse itsellensä suunnittelema.',
		},
		{
			year: 2009,
			description: 'Durex täyttää 80 vuotta!',
		},
		{
			year: 2010,
			description: 'Durex tukee YK:n väestörahaston Condomize!-hanketta kansainvälisessä AIDS-konferenssissa Wienissä lahjoittamalla sen käyttöön 220 000 kondomia.',
		},
		{
			year: 2010,
			description: 'Reckitt Benckinser ostaa Durexin',
		},
		{
			year: 2010,
			description: 'Durex esittelee Performax Intense -kondomin, joka on suunniteltu molempien osapuolten samanaikaiseen orgasmin saavuttamiseen. Kondomin sisäpinnalla on pinnoite, jossa on 5 % bentsokaiinia, ja kondomin rakenne auttaa tekemään seksistä pitkäkestoisempaa ja intensiivisempää.',
		},
		{
			year: 2019,
			description: 'Durex täyttää 90 vuotta!',
		},
	]
}